// src/layouts/MainLayout.jsx

import React from "react";
import logo from "../assets/iconos/logofinal_gov.png";
import logoBlanco from "../assets/fondos/LogoBlancoPiedecuestana.png";
import {FaTwitter,FaFacebook,FaInstagram,FaYoutube} from 'react-icons/fa';

export default function MainLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">

      {/* Header */}
      <header className="bg-primary text-white flex justify-between items-center px-6 py-3 shadow-md z-30">
        <div className="flex items-center gap-3">
          <a href="https://www.gov.co" target="_blank" rel="noopener noreferrer">
          <img src={logo} alt="Logo" className="h-8 w-auto"/>
          </a>
          <h1 className="font-semibold">
            Descarga tu Factura Piedecuestana E.S.P.
          </h1>
        </div>
      </header>

      {/* Contenido */}
      <main className="flex-1 bg-gray-50 p-6">
        {children}
      </main>

<footer className="bg-neutral-900 text-gray-300 pt-12 pb-6 text-sm">
  
  <div className="container mx-auto px-6">
    
    {/* CONTENEDOR HORIZONTAL */}
    <div className="flex flex-col md:flex-row items-start gap-12">
      
      {/* LOGO A LA IZQUIERDA */}
      <div className="flex-shrink-0">
        <img
          src={logoBlanco}
          alt="Logo Piedecuestana"
          className="w-60 h-auto opacity-95"
        />
        <div className="container mx-auto px-1 mt-2">
          <div className="grid md:grid-cols-4 gap-6">
            <a href="https://x.com/Piedecuestana_">
<FaTwitter size={24} className="text-white hover:text-gray-400"/>
            </a>
            <a href="https://www.facebook.com/PiedecuestanaESP/">
<FaFacebook size={24} className="text-white hover:text-gray-400"/>
            </a>
            <a href="https://www.instagram.com/explore/locations/517399849/piedecuestana-de-servicios-publicos-esp/">
<FaInstagram size={24} className="text-white hover:text-gray-400"/>
            </a>
            <a href="https://www.youtube.com/channel/UCxo9lqL0DHWyLH9VcwzxQbw">
<FaYoutube size={24} className="text-white hover:text-gray-400"/>
            </a>

          </div>
        </div>
      </div>

      {/* GRID DE 3 COLUMNAS */}
      <div className="grid md:grid-cols-3 gap-12 flex-1 text-center">

        {/* Líneas de atención */}
        <div >
          <h3 className="text-lg font-semibold mb-4 text-white">Líneas de atención</h3>

          <p className="text-white font-semibold">Reporte de emergencias</p>
          <p>WhatsApp: 316 744 4528</p>

          <p className="text-white mt-4 font-semibold">Email</p>
          <p>servicioalcliente@piedecuestanaesp.gov.co</p>
          <p>buzon@piedecuestanaesp.gov.co</p>

          <p className="text-white
          mt-4 font-semibold">Línea anticorrupción</p>
          <p>Móvil: 3167444528</p>

          <p className="text-white mt-4 font-semibold">Sede Administrativa</p>
          <p>Carrera 8 # 12-28, Barrio La Candelaria</p>
          <p>Piedecuesta, Santander, Colombia</p>
        </div>

        {/* Horarios */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-white">Horarios de atención</h3>

          <p className="text-white font-semibold">Lunes a viernes</p>
          <p>7:30 am - 4:30 pm (Jornada continua)</p>

          <p className="text-white mt-4 font-semibold">Ventanilla única</p>
          <p>7:30 am - 11:30 am</p>
          <p>1:30 pm – 4:30 pm</p>
          <p>recepcion@piedecuestanaesp.gov.co</p>
          <p>Notificaciones judiciales</p>
          <p>oficinajuridica@piedecuestanaesp.gov.co</p>

        </div>

        {/* Plantas */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-white">Plantas de Tratamiento</h3>

          <p className="text-white font-semibold">PTAP La Colina</p>
          <p>Carrera 19 # 6, Cabecera del Llano</p>

          <p className="text-white font-semibold mt-3">PTAR El Santuario</p>
          <p>Vereda Guatiguará</p>

          <p className="text-white font-semibold mt-3">PTAR La Diva</p>
          <p>Vereda Guatiguará – Sector La Diva</p>

        </div>

      </div>
    </div>

{/* SECCIÓN INFERIOR LINKS */}
<div className="container mx-auto px-4 mt-12">

  {/* GRID DE 3 COLUMNAS */}
  <div className="grid grid-cols-1 md:grid-cols-4 gap-10 text-center">

    {/*columna vacia*/}
    <div></div>

    {/* COLUMNA 1 */}
    <div>
      <a 
        href="https://piedecuestanaesp.gov.co/terminos-y-condiciones-sitio-web/"
        className="text-white font-semibold underline hover:text-gray-400 block"
      >
        Términos y condiciones
      </a>
    </div>

    {/* COLUMNA 2 */}
    <div>
      <a 
        href="https://piedecuestanaesp.gov.co/wp-content/uploads/2020/01/ACUERDO-NO.-011-DE-2018_POLI-TRATAMIENTO-DE-DATOS.pdf"
        className="text-white font-semibold underline hover:text-gray-400 block"
      >
        Política, privacidad y tratamiento de datos personales
      </a>

      <a 
        href="https://piedecuestanaesp.gov.co/politica-de-derechos-de-autor/"
        className="text-white font-semibold underline hover:text-gray-400 block mt-2"
      >
        Política de Derechos de Autor
      </a>

      <p className="text-gray-400 mt-4">Piedecuestana de Servicios Públicos E.S.P</p>
      <p className="text-gray-400">© {new Date().getFullYear()} Todos los derechos reservados</p>
      <p className="text-gray-400">By Duver Jaimes tel:3172115716</p>
    </div>

    {/* COLUMNA 3 */}
    <div>
      <a 
        href="https://piedecuestanaesp.gov.co/mapa-del-sitio/"
        className="text-white font-semibold underline hover:text-gray-400 block"
      >
        Mapa del sitio
      </a>
    </div>

  </div>
</div>

        {/* Línea inferior */}
    <div className="border-t border-gray-700 mt-10 pt-4 text-center text-xs text-gray-400 text-center"></div>
    <p className="text-center">empresa municipal de servicios públicos domiciliarios de Piedecuesta e.s.p. - Piedecuestana de Servicios Públicos - Piedecuesta, Santander Dream-Theme — truly premium WordPress themes</p>
    </div>
   </footer>
</div>
  );
}
